import React, { useMemo } from 'react';

import { ProductItem, Status } from 'components/Atoms';
import { number } from 'prop-types';
import { formatFirstValue, formatValueCents } from 'utils/formatValue';
import BackIcon from 'assets/images/icons/back.svg';

import * as T from './interfaces';
import { MenuItem } from './MenuItem';
import * as S from './styles';

export const Container = ({
  id,
  children,
  title,
  labels,
  img,
  price,
  unavailable,
  imgOutsideContainer,
  ...rest
}: T.IMenuContainerProps) => {
  const shouldHaveMargin = useMemo(() => {
    if (Number(id) === 2) return true;
    if (Number(id) === 5) return true;
    const result = (Number(id) + 3) % Number(id) === 3;
    return result;
  }, [id]);

  return (
    <MenuItem
      unavailable={unavailable}
      shouldHaveMargin={shouldHaveMargin}
      imgOutsideContainer={imgOutsideContainer}
      {...rest}
      id={`id@${id}`}
    >
      <ProductItem
        size="Adaptable"
        textAlign="left"
        variant="primary"
        id="productItem"
      >
        <img src={img} alt={title} />
        <S.TitleContainer>
          <h2>{title}</h2>
        </S.TitleContainer>
      </ProductItem>
      <S.StatusContainer>
        {labels.map((status: string, index: number) => (
          <Status id={`${index}`} status="active" key={index}>
            {status}
          </Status>
        ))}
      </S.StatusContainer>
      <S.PriceContainer>
        {unavailable ? (
          <p>Produto indisponível</p>
        ) : price ? (
          <>
            <p>R$</p>
            <p>{formatFirstValue(price)}</p>
            <p>{formatValueCents(price)}</p>{' '}
          </>
        ) : (
          <>
            <p>Saiba mais</p>
            <img src={BackIcon} sizes="10" alt="Seta para direita" />
          </>
        )}
      </S.PriceContainer>
    </MenuItem>
  );
};
